<!doctype html>
<html lang="en">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <title>Corncall Video</title>
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">

  <style>
    .header {
    float: left;
    width: 100%;
    margin-bottom: 20px;
   }
   .header-top {
    float: left;
    width: 100%;
}
.header-paddg {
    padding: 0px 200px;
}
.logo-cnt img {
    width: 130px;
}
ul.rt-menu {
    list-style: none;
    padding: 0;
    float: right;
    margin-bottom: 0;
    margin-top: 3px;
}
ul.rt-menu li {
    display: inline-block;
    padding-left: 10px;
}
ul.main-menu {
    list-style: none;
    padding: 0;
    margin: 0;
    float: left;
    width: 100%;
}
.header-menu {
    float: left;
    width: 100%;
    background: #09402e;
}
ul.main-menu li {
    display: inline-block;
    float: left;
}
ul.main-menu li a {
    color: #fff;
    padding: 10px;
    background: #94c63a;
    text-decoration: none;
    display: inline-block;
    font-size: 18px;
}
ul.main-menu li:last-child a {
    border-right: 0px;
}
ul.main-menu li a {
    color: #fff;
    padding: 10px 25px;
    background: #94c63a;
    text-decoration: none;
    display: inline-block;
    font-size: 18px;
    border-right: 1px solid #b8f747;
}
ul.main-menu li a:hover {
    background: #598211;
    transition: all .5s ease-in;
}
ul.rt-menu li a i {
    color: #94c63a;
    font-size: 22px;
    display: inline-block;
    vertical-align: bottom;
    margin-right: 3px;
}
ul.rt-menu li a {
    color: #5f5f5f;
    text-decoration: none;
}
.nopadding{
  padding: 0;
}
.header-top1 {
    float: left;
    width: 100%;
    padding: 12px 0;
}
.left-menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
    float: left;
    width: 100%;
    background: #86b437;
    text-align: center;
    /* min-height: 700px; */
}
.video-list img {
    width: 100%;
}

.video-conf h2 {
    font-size: 22px;
    color: #85b236;
    margin-top: 0px;
    margin-bottom: 0;
    padding: 20px 0;
    float: left;
    width: 100%;
}
.left-menu ul li {
    float: left;
    width: 100%;
}
.left-menu-p img {
    width: 100%;
    max-width: 45px;
    margin: 0 auto 10px;
}
.left-menu-p {
    float: left;
    width: 100%;
    text-align: center;
}
.left-menu ul li a:hover {
    transition: all .5s ease-in;
    background: #86b437;
}
.left-menu ul li a {
    background: #a5cd65;
    display: inline-block;
    width: 100%;
    margin-bottom: 20px;
    text-decoration: none;
    padding: 15px 0 10px;
}
.left-menu h3 {
    color: #fff;
    font-size: 15px;
}
.video-list {
    float: left;
    width: 100%;
}
.video-list-full img {
    width: 100%;
}
.video-list-full {
    float: left;
    width: 100%;
    margin-top: 20px;
    position: relative;
}
.vid-lsting ul {
    list-style: none;
    padding: 0;
    margin: 0;
    float: left;
    width: 100%;
    text-align: left;
}
.vid-lsting {
    float: left;
    width: 100%;
    height: 700px;
    overflow: scroll;
}
.vid-lsting ul li {
    float: left;
    width: 100%;
    margin-bottom: 10px;
}
.vid-lis-im {
    float: left;width: 100%;text-align: left;position: relative;background: #94c63a; border-radius: 5px;
}
.vid-lis-im img {
    width: 100%;border-radius: 5px 5px 0 0;
}
.listing-ic a i {
    color: #94c63a;margin-right: 2px;
}
.listing-ic {
    position: absolute;top: 0;right: 0;text-align: center;background: #09402e;border-radius: 5px 0px 0px 5px;padding: 6px;
}
.vid-lis-im h4 {
    float: left;width: 100%;padding: 0 10px;font-size: 13px;text-align: center;font-weight: 600;margin: 5px 0;color: #fff;
}
.listing-ic a i:hover {
    color: #fff;
}
.chattingh h3 i {
    margin-right: 3px;
}
.topclose button {
    background: #1f3104 !important;
    border: 0;
}
.topclose {
    position: absolute;
    right: -19px;
    top: -13px;
}
.chattingh h3 {
    float: right;
    padding: 10px;
    font-size: 15px;
    margin: 0 0 10px;
    color: #09402e;
    font-weight: 600;
    background: #a5cd65;
    width: 100%;
    text-align: left;
}
.chattingh {
    float: left;
    width: 100%;
    border: 1px solid #a5cd65;
    min-height: 700px;
}
.videocall-btns ul li a i {
    width: 50px;
    height: 50px;
    line-height: 50px;
    background: #00a24f;
    color: #fff;
    font-size: 30px;
    border-radius: 50%;
}
.videocall-btns ul li {
    display: inline;
    padding: 10px;
}
.videocall-btns ul {
    list-style: none;
    padding: 0;
    margin: 0;
    float: left;
    width: 100%;
    text-align: center;
}
.videocall-btns ul li:first-child a i {
    background: #e33e27 !important;
}
.videocall-btns {
    position: absolute;text-align: center;left: 50%;transform: translateX(-50%);bottom: 30px;
}
.obj input {
    width: 50% !important;
}
.obj label {
    width: 50%;
    float: left;
    font-weight: 100;
}
.saveandne {
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    padding-top: 14px;
    margin-top: 20px;
}
.correctanss input {
    margin-bottom: 18px !important;
}
p.quesh {
    font-size: 15px;
    color: #1f3104;
    font-weight: 600;
}
.header-menu h2 {
    color: #fff;
    float: left;
    width: 100%;
    text-align: center;
    margin: 0;
    padding: 10px;
    font-size: 20px;
    text-transform: uppercase;
}
.video-list-full video {
    height: 395px;
    width: 100%;
}
  </style>

<style>
  .group-chat {
     position: absolute;
     bottom: 0;
     right: 0;
     width: 100%;
 }
 .group-chat-cnt {
    float: left;
    width: 100%;
    background: #1981a3;
    padding: 20px;
    border-radius: 20px 20px 0 0;
}
.group-chat-cnt input {
    border: 2px solid #07485d;
    padding: 12px;
    width: 90%;
    float: left;
    border-radius: 5px 0 0px 5px;
}
button.enttsx {
    width: 10%;
    float: left;
    background: #07485d;
    border: none;
    color: #fff;
    font-size: 20px;
    padding: 10px;
    border-radius: 0px 5px 5px 0;
}
.chatting-cnt {
    float: left;
    width: 100%;
    position: relative;
}
.chatting-inner {
  position: relative;
    background: #fff;
    float: left;
    width: 100%;
}
.msg_card_body {
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    overflow-y: auto;
}
.img_cont_msg {
    height: 50px;width: 50px;border: 2px solid #ccc;text-align: center;border-radius: 50%;
}
.rounded-circle {
        border-radius: 50%!important;height: 50px; width: 50px;object-fit: cover;
}
.msg_cotainer {
    margin-top: auto;margin-bottom: auto;margin-left: 10px;border-radius: 25px;background-color: #09402e;padding: 10px;position: relative;min-width: 100px;text-align: left;font-size: 14px;font-weight: 600;color: #fff;
}
.msg_time {
    position: absolute;left: 0;bottom: -22px;color: #000;font-size: 12px;
}
.justify-content-end {
    -ms-flex-pack: end!important;justify-content: flex-end!important;
}
.d-flex1 {
    display: -ms-flexbox!important;display: flex!important;float: left;width: 100%; margin-bottom: 35px;-ms-flex-pack: start!important;justify-content: flex-start!important;
}
.justify-content-start {-ms-flex-pack: start!important;justify-content: flex-start!important;
}

.msg_cotainer_send {
    margin-top: auto;margin-bottom: auto;margin-right: 10px;border-radius: 25px;background-color: #a5cd65;padding: 10px;position: relative;min-width: 100px;text-align: left;font-size: 14px;font-weight: 600;
}
.msg_time_send {
    position: absolute;right: 0; bottom: -22px;color:#000;font-size: 12px;
}
.card-footer1 {
    float: left;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    background: #a5cd65;
    border-radius: 10px 10px 0 0;
    padding: 13px 20px 12px;
    z-index: 11;
}
.input-group1 {
    width: 100%;
    float: left;
}
.input-group-append i, .input-group-append1 i {
    color: #fff;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
}

.input-group1 textarea {
  float: left;
    width: 80%;
    position: relative;
    border: 2px solid #a5cd65;
    border-radius: 5px 0 0 5px;
    background: #fff;
    padding: 10px;
    height: 40px;
    color: rgb(0, 0, 0);
    resize: none;
}
.input-group-append {
    float: left;
    width: 10%;
    display: none;
}
.input-group-append1 {
    float: left;
    width: 20%;
    text-align: center;
    background: #09402e;
    border-radius: 0px 5px 5px 0;
}
.chatt {
    padding: 0;
}

.msg_card_body {
    float: left;
    width: 100%;
}
.msg_card_body-inner {
    float: left;
    width: 100%;
    height: 587px;
    overflow: auto;
    margin-bottom: 65px;
    padding: 0 10px;
}
.mid-container {
    padding: 230px 0;
    float: left;
    width: 100%;;
}
.right-cnt {
    float: left;
    width: 100%;
    text-align: right;
    position: relative;
    height: 100%;
}
.right-cnt img {
    width: 100%;
    height: 970px;
    object-fit: scale-down;
}
button.addQuestionButton {
    background: #a2ce5e; border: 1px solid #96ca46;padding: 5px 15px;font-size: 14px;margin-bottom: 13px;
}
button.closeModelButton {
    float: right;background: #ce1717;color: #fff; padding: 5px 15px; font-size: 14px;margin-bottom: 13px;
}
button.closeModelButton i {
    width: 17px;
    height: 17px;
    line-height: 15px;
    border-radius: 50%;
    border: 2px solid #fff;
    font-size: 10px;
    margin-right: 3px;
}
button.addQuestionButton i{
  margin-right: 5px;
}
.optionsClass label {
    padding-left: 10px;
}
.saveAndSendButton {
    float: right;
    background: #1f3104 !important;
}
@media only screen and (max-width: 991px) {
  .videocall-btns ul li a i {width: 40px;height: 40px;line-height: 40px;font-size: 19px;}
  .videocall-btns ul li {padding: 2px;}
}

@media only screen and (max-width: 767px) {
  .header-paddg {padding: 0px 20px;}
  .logo-cnt img { width: 100%;}
  .left-menu ul li {width: 25%;}
  .left-menu h3 {font-size: 15px;min-height: 52px;}
  .left-menu-p img {max-width: 30px;}
  .left-menu {float: left;width: 100%;margin-bottom: 0px;}
  .left-menu ul li a {margin-bottom: 0px;}
  .video-list {display: none;}
  .video-list-full video {height: auto;margin-bottom: 15px;}
  .vid-lsting ul li {width: 33.3%;     padding: 5px;}
  .vid-lsting {height: 203px;margin-bottom: 8px;}
  .header-menu h2 {font-size: 16px;}
  .chattingh {min-height: auto;}
  .msg_card_body-inner {height: 115px;}
  .card-footer1 { position: fixed;}
}

   </style>
<style>

p.plzselect {
    font-size: 15px;
    background: #a2ce5e;
    padding: 5px 10px;
    color: #fff;
    text-shadow: 0px 1px 10px #1f3104;
}
.modal-content2 label {
    color: #1f3104;
}
.objectivediv input {
    width: 100%;
    border: 1px solid #a2ce5e;
    margin-bottom: 10px;
}
/* The Modal (background) */
.modal2 {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content2 {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 100%;
  max-width: 700px;
  position: relative;
}

/* The Close Button */
.close2 {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close2:hover,
.close2:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
</style>


  <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/jquery.blockUI/2.70/jquery.blockUI.min.js" ></script>
	<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.4.1/js/bootstrap.min.js"></script>
	<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/bootbox.js/5.4.0/bootbox.min.js"></script>
	<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/spin.js/2.3.2/spin.min.js"></script>
	<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/toastr.js/2.1.4/toastr.min.js"></script> -->

	<!-- <script type="text/javascript" src="src/assets/js/janus.js" ></script> -->
	<!-- <script src="src/assets/js/adapter.min.js"></script> -->
<!-- JavaScript -->

</head>

<body onunload="closingAlert()">

  <div class="header">

    <div class="container-fluid nopadding">

        <div class="header-top header-paddg">
          <div class="header-top1">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5">
                    <div class="logo-cnt"><img src="assets/videoroom/CornCall.png"></div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7">
                    <ul class="rt-menu">
                      <li><a href="#"> <i class="fa fa-cog" aria-hidden="true"></i> Settings</a></li>
                      <li><a href="#"> <i class="fa fa-sign-out" aria-hidden="true"></i> Sign Out</a></li>
                    </ul>
                  </div>
                </div>
          </div>
        </div>

        <div class="header-menu header-paddg">
          <h2><span id='webinarName'>Scheduled Webinar List</span></h2>
        </div>

    </div>
  </div>

  <div class="container-fluid">
     <div class="video-conf">

        <div class="row">
          <div class="col-lg-1 col-md-2 col-sm-2">
          <div class="left-menu">
             <ul>
			 <li class="forAdmin">
                 <a onclick ="shareScreen();">
                   <div class="left-menu-p"><img src="assets/videoroom/share-screen1.png" id="shareScreen"></div>
                   <h3>Share Screen</h3>
                 </a>
                </li>
               <li class="forUser">
                 <a onclick ="sendRaiseHand();">
                   <div class="left-menu-p"><img src="assets/videoroom//raisehand.png"></div>
                   <h3>Raise Hand</h3>
                 </a>
                </li>

                <li class="forAdmin">
                  <a onclick ="addQuestion();">
                    <div class="left-menu-p"><img src="assets/videoroom/add-question.png"></div>
                    <h3>Add Question</h3>
                  </a>
                 </li>

                <li class="forAdmin">
                  <a   onclick="showQuestionModal();">
                    <div class="left-menu-p"><img src="assets/videoroom/ask-question.png"></div>
                    <h3>Ask Question</h3>
                  </a>
                 </li>
                 <li >
                  <a onclick="focusOnGrpChat();">
                    <div class="left-menu-p"><img src="assets/videoroom//chat.png"></div>
                    <h3>Chat</h3>
                  </a>
                 </li>
                 <li>
                  <a href="#">
                    <div class="left-menu-p"><img src="assets/videoroom//leave.png"></div>
                    <h3>Leave</h3>
                  </a>
                 </li>
             </ul>
          </div>
          </div>

          <div class="col-lg-9 col-md-6 col-sm-6 nopadding">

            <div class="col-lg-10 col-md-8 col-sm-8 nopadding">

              <div class="video-list" style="display: none;">
                <div class="row">
                  <div class="col-sm-4"><video width="100%" height="auto" controls><source src="assets/videoroom//movie.mp4" type="video/mp4"></video></div>
                  <div class="col-sm-4"><video width="100%" height="auto" controls><source src="assets/videoroom//movie.mp4" type="video/mp4"></video></div>
                  <div class="col-sm-4"><video width="100%" height="auto" controls><source src="assets/videoroom//movie.mp4" type="video/mp4"></video></div>
                </div>
              </div>
              <div class="video-list-full">
                <div class="row">
                  <div class="col-sm-6" id="videolocal">
                    <!-- <img src="images/v4.png"> -->
                    <!-- <video width="100%" height="auto" controls><source src="assets/videoroom//movie.mp4" type="video/mp4"></video> -->
                    <!-- <div class="videocall-btns">
                      <ul>
                        <li><a href="#"><i class="fa fa-phone" aria-hidden="true"></i></a></li>
                        <li ><a onclick="toggleMute();" id="mute1"><i class="fa fa-microphone" aria-hidden="true"></i></a></li>
                        <li><a  onclick="unpublishOwnFeed();"><i class="fa fa-video-camera" aria-hidden="true"></i></a></li>
                      </ul>
                    </div> -->
                  </div>
				  <div class="col-sm-6" id="videoremote1">
                    <!-- <img src="images/v4.png"> -->
                    <!-- <video width="100%" height="auto" controls><source src="assets/videoroom//movie.mp4" type="video/mp4"></video> -->
                    <!-- <div class="videocall-btns">
                      <ul>
                        <li><a href="#"><i class="fa fa-phone" aria-hidden="true"></i></a></li>
                        <li><a href="#"><i class="fa fa-microphone" aria-hidden="true"></i></a></li>
                        <li><a href="#"><i class="fa fa-video-camera" aria-hidden="true"></i></a></li>
                      </ul>
                    </div> -->
					<h3 class="panel-title"><span class="label label-info hide" id="remote1"></span></h3>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-lg-2 col-md-4 col-sm-4 nopadding1">
              <div class="vid-lsting">
			  <!-- <span id="userCount">0</span> -->
                <ul id = 'userListNew'>

                </ul>
              </div>
            </div>

          </div>

          <div class="col-lg-2 col-md-4 col-sm-4">
            <ul class="nav nav-tabs" id="individualUserList">
              <li class="active"><a data-toggle="tab" href="#home" onclick="prepareChatMessageDisplayForIndividual();">Group</a></li>

              </ul>
             <div class="chattingh" id="grpvidualChatList">
                <h3><i class="fa fa-users" aria-hidden="true"></i> Group Chat</h3>

                <div class="chatting-cnt">
                  <div class="chatting-inner">

                    <div class="msg_card_body">
                      <div class="msg_card_body-inner" id="innerMsg">



                    </div>
                  </div>


                    <div class="card-footer1">
                      <div class="input-group1">
                        <div class="input-group-append"><span class="input-group-text attach_btn"><i class="fa fa-paperclip"></i></span></div>
                        <textarea name="" class="type_msg" id="type_msg" placeholder="Type your message..."></textarea>
                        <div class="input-group-append1"><span class="input-group-text send_btn"><i class="fa fa-location-arrow"></i></span></div>
                      </div>
                    </div>

                  </div>
                </div>

             </div>

             <div  id="individualChatList" class="chattingh" style="display: none;">
              <h3><i class="fa fa-users" aria-hidden="true"></i> Individual Chat</h3>
              <div class="chatting-cnt">
                <div class="chatting-inner">

                  <div class="msg_card_body">
                  <div class="msg_card_body-inner" id="innerMsgForIndi">



                  </div>
                </div>


                  <div class="card-footer1">
                  <div class="input-group1">
                    <div class="input-group-append"><span class="input-group-text attach_btn"><i class="fa fa-paperclip"></i></span></div>
                    <textarea name="" class="type_msg" id="type_msgForIndi" placeholder="Type your message..."></textarea>
                    <div class="input-group-append1"><span class="input-group-text send_btn" onclick="getChatAndSendForIndi();"><i class="fa fa-location-arrow"></i></span></div>
                  </div>
                  </div>

                </div>
                </div>



             </div>

          </div>

        </div>

     </div>
  </div>

<!-- <div>

  <div class="modal fade" id="myModal" role="dialog">
    <div class="modal-dialog">


      <div class="modal-content">
        <div class="modal-header">

          <button type="button" class="btn btn-info btn-lg" >Add Question</button>
        </div>
        <div class="modal-body">
          <p id="noQuestionFound">No Question</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div>
      </div>

    </div>
  </div>
</div> -->
<div>
  <div class="modal2" id="mySubJectiveAnswer" >
    <div class="modal-content2">
<input type="hidden" name="qID" id="qID" value="">
<input type="hidden" name="qType" id="qType" value="">
      <div class="py-2 h5"><b><span id="question"></span></b></div>
      <div class="py-2 h5" id="showsubejectiveAnswer">
<textarea name="subejectiveAnswer" id="subejectiveAnswer" cols="30" rows="10" style="width: 100%;border: 1px solid #a2ce5e;"></textarea>
      </div>
      <div class="optionsClass" id="options">
        <input type="radio" name="radio" value="1"><label for="options1" >  </label> <br />
       <input type="radio" name="radio" value="2"><label for="options2"></label> <br />
        <input type="radio" name="radio" value="3"><label for="options3">  </label><br />
       <input type="radio" name="radio" value="4">  <label for="options4">   </label></div> <br />
       <div class="row">
         <div class="col-sm-6">
          <button type="button" class="btn btn-info btn-lg addQuestionButton" onclick="saveAnswerByUser();" >Submit Answer</button><span></span></div>
          <div class="col-sm-6"><button type="button" class="btn btn-default closeModelButton" data-dismiss="modal" onClick="closeModel('mySubJectiveAnswer');"><i class="fa fa-times"></i>Close</button></div>
        </div>
    </div>
  </div>
</div>
<div id="myModal" class="modal2">

  <!-- Modal content -->
  <div class="modal-content2">
    <div class="row ">
      <div class="col-sm-6 ">
      <button type="button" class="btn btn-info btn-lg addQuestionButton" onclick="addQuestion();"><i class="fa fa-plus"></i> Add Question</button></div>
      <div class="col-sm-6 "> <button type="button" class="btn btn-default closeModelButton" data-dismiss="modal" onClick="closeModel('myModal');"><i class="fa fa-times"></i> Close</button></div>
    </div>

    <p id="noQuestionFound">No Question</p>

  </div>
  <div class="modal-body">

  </div>
  <div class="modal-footer">

  </div>

</div>


<div id="addQuestionNew" class="modal2">

  <!-- Modal content -->
  <div class="modal-content2">
    <div class="topclose"><button type="button" data-dismiss="modal" class="btn btn-default closeModelButton" onClick="closeModel('addQuestionNew');"><i class="fa fa-times" aria-hidden="true"></i></button></div>
    <p class="plzselect">Please select your Question Type:</p>
    <input type="radio" id="obj" name="qTypeforSave" value="2">
    <label for="obj" style=" padding-left: 10px;padding-right: 10px; padding-bottom: 15px;">Objective</label>
    <input type="radio" id="sub" name="qTypeforSave" value="1">
    <label for="sub" style=" padding-left: 10px;padding-right: 10px; padding-bottom: 15px;">SubJective</label><br>
    <textarea name="subejectiveQuestion" id="subejectiveQuestion" cols="30" rows="10" style="display: none;border: 1px solid #a2ce5e;width: 100%;height: 125px;margin-bottom: 20px;"></textarea>
    <div id="forQobjectiveSave" class="objectivediv" style="display: none;">
       <p class="quesh">Enter Your Question:</p>
       <input type="text" name="subQuestionSave" id ="subQuestionSave">

      <div class="obj">
        <div class="row">
          <div class="col-sm-6">
            <p class="quesh">Enter Your Options:</p>
            <label for="opA">Option A</label>
            <input type="text" name="optQuestionSaveA" id ="optQuestionSaveA">
            <label for="opB">Option B</label>
            <input type="text" name="optQuestionSaveB" id ="optQuestionSaveB">
            <label for="opC">Option C</label>
            <input type="text" name="optQuestionSaveC" id ="optQuestionSaveC">
            <label for="opC">Option D</label>
            <input type="text" name="optQuestionSaveD" id ="optQuestionSaveD">
          </div>

          <div class="col-sm-6 correctanss">
            <p class="quesh">Correct Options:</p>
            <label for="opA">Option A</label>
            <input type="radio" name="correctAnswer" value="1" checked>
            <label for="opB">Option B</label>
            <input type="radio" name="correctAnswer" value="2">
            <label for="opC">Option C</label>
            <input type="radio" name="correctAnswer" value="3">
            <label for="opC">Option D</label>
            <input type="radio" name="correctAnswer" value="4">
          </div>
        </div>
      </div>

    </div>
    <div class="saveandne">
      <div class="row">
        <div class="col-sm-6">
          <button type="button" class="btn btn-info btn-lg addQuestionButton" onclick="saveQuestion();" >Save Question</button><span></span>
        </div>
        <div class="col-sm-6">
          <button type="button" class="btn btn-info btn-lg addQuestionButton saveAndSendButton" onclick="saveQuestionAndSend();" >Save And Send Question</button><span></span>
        </div>
      </div>
    </div>

  </div>


</div>

</body>


<script type="text/javascript">
  window.addEventListener("beforeunload", function (e) {
  var confirmationMessage = "\o/";

  (e || window.event).returnValue = confirmationMessage; //Gecko + IE
  return confirmationMessage;                            //Webkit, Safari, Chrome
});
</script>

</html>
